import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'sera-toast',
    templateUrl: './sera-toast.component.html',
    styleUrls: ['./sera-toast.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SeraToastComponent {}
